import { cn } from '@/lib/utils'

const assetBaseUrl = (
  import.meta.env.VITE_ASSET_URL || 'https://dev-cf.myonestem.com/assets/admin'
).replace(/\/+$/, '')

function appUpdateAssetUrl(filename) {
  return `${assetBaseUrl}/whats-new/${filename}`
}

const fallbackThumbnails = {
  bug: {
    image: appUpdateAssetUrl('bug-fix.jpg'),
    label: 'Bug Fix',
  },
  new_feature: {
    image: appUpdateAssetUrl('new-feature.jpg'),
    label: 'New Feature',
  },
  performance: {
    image: appUpdateAssetUrl('performance.jpg'),
    label: 'Performance',
  },
  security: {
    image: appUpdateAssetUrl('security.jpg'),
    label: 'Security',
  },
  ui_ux: {
    image: appUpdateAssetUrl('ui-ux.jpg'),
    label: 'UI/UX',
  },
}

function getFallbackConfig(updateType, updateTypeLabel) {
  const config = fallbackThumbnails[updateType]

  if (config) {
    return config
  }

  return {
    image: appUpdateAssetUrl('new-feature.jpg'),
    label: updateTypeLabel || 'App Update',
  }
}

export function AppUpdateThumbnail({
  appUpdate,
  media = appUpdate?.thumbnail,
  title = appUpdate?.title,
  updateType = appUpdate?.update_type,
  updateTypeLabel = appUpdate?.update_type_label,
  className,
  imageClassName,
}) {
  if (media?.url) {
    return (
      <img
        src={media.url}
        alt={media.name || title || 'App update thumbnail'}
        className={cn('aspect-video w-full rounded-lg object-cover', imageClassName, className)}
      />
    )
  }

  const fallback = getFallbackConfig(updateType, updateTypeLabel)

  return (
    <img
      src={fallback.image}
      alt={fallback.label + ' app update thumbnail'}
      className={cn('aspect-video w-full rounded-lg object-cover', imageClassName, className)}
    />
  )
}
